import App from '../app';
import {User} from '../model/User';
import currentSession from './currentSession';

export default function currentUser(): User | null {
  const {userId} = currentSession();
  return App.useQuery(state => state.user.get(userId.id));
}